module.exports = __webpack_public_path__ + "img/filter-ascending-icon.27548714.svg";